import { leagueRequiresRound } from './league-config';

export const shouldShowField = (fieldKey: string, formData: any): boolean => {
  if (fieldKey === 'round') {
    return leagueRequiresRound(formData.league);
  }

  return true;
};
